import React, { type CSSProperties, type ReactNode } from 'react';

type Props = {
  style?: CSSProperties;
  onClick: () => void;
  children: ReactNode;
};

function LibItemContainer({ style, onClick, children }: Props) {
  return (
    <div
      style={style}
      className="flex h-full cursor-pointer items-center border-b px-20 hover:bg-white-light"
      onClick={() => onClick()}
    >
      {children}
    </div>
  );
}

export default LibItemContainer;
